import React from "react";
import {
  FormDataConsumer,
  Labeled,
  useTranslate,
  useQueryWithStore,
} from "react-admin";
import { get } from "lodash";
import { Typography } from "@material-ui/core";

const InfoFieldWrapper = ({ bookmakerId, userId, day, ...props }) => {
  const translate = useTranslate();
  const { data, loaded } = useQueryWithStore({
    type: "getInfo",
    resource: "stats",
    payload: {
      user_id: userId,
      bookmaker_id: bookmakerId,
      range: day,
    },
  });
  if (!loaded) {
    return null;
  }
  return (
    <Labeled label={translate("resources.stats-declinated.fields.generated")}>
      <Typography variant="body1">{get(data, "generated")}</Typography>
    </Labeled>
  );
};
const processForm = ({ formData, ...rest }) => {
  const bookmakerId = get(formData, "bookmaker_id", 0);
  const userId = get(formData, "user_id", 0);
  const day = get(formData, "day", null);
  if (bookmakerId > 0 && userId > 0 && day !== null) {
    return (
      <InfoFieldWrapper
        bookmakerId={bookmakerId}
        userId={userId}
        day={day}
        {...rest}
      />
    );
  }
  return null;
};

const InfoField = (props) => (
  <FormDataConsumer {...props}>{processForm}</FormDataConsumer>
);
export default InfoField;
